'use client';

import { Label } from '@kit/ui/label';

import { CurrencySelect } from '~/components/currency-select';

/**
 * Currency picker for the public calculators.
 *
 * These tools do arithmetic on figures the visitor types in, so the currency
 * is a label rather than a conversion: enter AUD costs and every result is
 * AUD. No rate is applied and none is needed — which is also why mixing
 * currencies across the inputs of a single calculation would be wrong.
 */
export function CurrencyPicker(props: {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  label?: string;
  hint?: string;
  /** Overrides the select's surface, for calculators that sit it on a tint. */
  selectClassName?: string;
}) {
  const id = props.id ?? 'calculator-currency';

  return (
    <div className="space-y-2">
      <Label
        htmlFor={id}
        className="text-muted-foreground text-sm font-semibold"
      >
        {props.label ?? 'Currency'}
      </Label>

      <CurrencySelect
        className={
          props.selectClassName ??
          'border-border bg-muted focus-visible:ring-primary/20 h-12 rounded-xl shadow-none focus-visible:ring-2'
        }
        id={id}
        onChange={props.onChange}
        value={props.value}
      />

      <p className="text-muted-foreground text-xs">
        {props.hint ?? 'Enter every figure below in this currency.'}
      </p>
    </div>
  );
}
